export default "__VITE_ASSET__Cd1c6RTN__"